import { getResourceTo } from './utils';

const isPositionSourceValid = (positionSource) =>
  positionSource?.sourceType && positionSource?.source;

export const getPositionSourceNameForTrackCompany = (positionSource) => {
  if (
    positionSource?.sourceType === 'MOBILE' ||
    !isPositionSourceValid(positionSource)
  ) {
    return '';
  }
  const capitalizeText = (text) => {
    if (!text) return '';
    return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
  };

  return capitalizeText(positionSource?.source);
};

export const getPositionSourceName = (positionSource) => {
  if (!isPositionSourceValid(positionSource)) {
    return '';
  }

  const resourceName = getResourceTo(
    `positionSource.sourceType.${positionSource?.sourceType?.toLowerCase()}`
  );
  const sourceLabel =
    positionSource?.sourceType === 'MOBILE'
      ? `${resourceName} (${getResourceTo(positionSource.key)})`
      : `${resourceName} (${getPositionSourceNameForTrackCompany(positionSource)})`;

  return sourceLabel || positionSource.sourceType;
};

export const sortCoordinatesByDate = (a, b) => {
  const millisecondsDateNextCoordinate = Monet.Format.DateTime.parse(
    a.get('date')
  ).getTime();
  const millisecondsActualCoordinate = Monet.Format.DateTime.parse(
    b.get('date')
  ).getTime();
  return millisecondsDateNextCoordinate - millisecondsActualCoordinate;
};

export const getMostRecentCoordinate = (positionSourcesCollection) => {
  if (!positionSourcesCollection || positionSourcesCollection.length === 0) {
    return null;
  }
  const mostRecentCoordinate = positionSourcesCollection
    .map((positionSource) => {
      const coordinates = positionSource
        .get('coordinates')
        .sortCoordinatesByDate();
      return coordinates.at(coordinates.length - 1);
    })
    .sort(sortCoordinatesByDate)
    .at(-1);

  return mostRecentCoordinate;
}
